import { toUrl } from '@/lib/utils';
export default function ConcertsBox({
    concerts,
}) {
    return (
        concerts &&
        concerts.length > 0 && (
            <div className="min-h-50vh px-2 py-8 md:px-8 overflow-hidden">
                <div className="flex flex-col divide-y-1 divide-border">
                    {concerts.map((concert) => (
                        <Concert key={`${concert.city}_${concert.starts_at_date}`} concert={concert} />
                    ))}
                </div>
            </div>
        )
    );
}

function Concert({ concert }) {
    const {
        starts_at_time,
        starts_at_date,
        offer_url,
        sold_out,
        city,
        name,
    } = concert;


    return (
        <div className="grid grid-cols-[5rem_1fr_5rem] py-2">
            <div className="flex items-center justify-center">
                <div className="flex flex-col items-center">
                    <span>{starts_at_time}</span>
                    <span className="font-bold">{starts_at_date}</span>
                </div>
            </div>
            <div className="flex flex-col items-center truncate">
                <span className="text-lg font-bold uppercase">
                    {city}
                </span>
                <span className="max-w-[12rem] truncate text-muted lg:max-w-[40rem]">
                    {name}
                </span>
            </div>

            <div className="flex items-center justify-end">
                {offer_url && !sold_out && (
                    <a
                        href={toUrl(offer_url)}
                        rel='noopener noreferrer'
                        target='_blank'
                        className='underline hover:bg-primary hover:text-secondary'

                    >Tickets</a>
                )}
                {sold_out && (
                    <span className="text-muted line-through">Sold Out</span>
                )}
                {!offer_url && !sold_out && <span></span>}
            </div>
        </div>
    );
}
